export type ConsumptionPointScope = 'AllConsumptionPoints' | 'SpecificConsumptionPoints';

export const ConsumptionPointScope = {
    AllConsumptionPoints: 'AllConsumptionPoints' as ConsumptionPointScope,
    SpecificConsumptionPoints: 'SpecificConsumptionPoints' as ConsumptionPointScope
};
